<template>
  <ServicePageLayout
    icon="fas fa-project-diagram"
    title="Institutional Programs & Services"
    subtitle="Comprehensive programs supporting student success and development"
  >
    <section class="content-section">
      <h2>
        <i class="fas fa-info-circle section-icon" />
        Overview
      </h2>
      <p>
        The Office of Student Affairs and Services offers a variety of institutional programs
        designed to support students throughout their academic journey. These programs are
        developed in alignment with CHED guidelines and institutional objectives to ensure
        holistic student development.
      </p>
    </section>

    <section class="content-section">
      <h2>
        <i class="fas fa-th-large section-icon" />
        Key Programs
      </h2>
      <div class="programs-grid">
        <div class="program-card featured">
          <div class="program-icon">
            <i class="fas fa-user-graduate" />
          </div>
          <h3>Student Orientation Program</h3>
          <p>
            Comprehensive orientation for new students covering academic expectations,
            campus life, support services, and institutional policies.
          </p>
          <span class="program-tag">Every Semester</span>
        </div>
        <div class="program-card">
          <div class="program-icon yellow">
            <i class="fas fa-chalkboard-teacher" />
          </div>
          <h3>Student Development Seminars</h3>
          <p>
            Regular seminars on life skills, personal development, and character formation.
          </p>
          <span class="program-tag">Quarterly</span>
        </div>
        <div class="program-card">
          <div class="program-icon">
            <i class="fas fa-brain" />
          </div>
          <h3>Mental Health Awareness Program</h3>
          <p>
            Initiatives promoting mental wellness, stress management, and psychological support.
          </p>
          <span class="program-tag">Year-round</span>
        </div>
        <div class="program-card">
          <div class="program-icon yellow">
            <i class="fas fa-briefcase" />
          </div>
          <h3>Career Development Program</h3>
          <p>
            Job fairs, resume workshops, mock interviews, and industry exposure activities.
          </p>
          <span class="program-tag">Annual</span>
        </div>
        <div class="program-card">
          <div class="program-icon">
            <i class="fas fa-hands-helping" />
          </div>
          <h3>Community Outreach Program</h3>
          <p>
            Service-learning activities connecting students with community needs.
          </p>
          <span class="program-tag">Monthly</span>
        </div>
        <div class="program-card">
          <div class="program-icon yellow">
            <i class="fas fa-trophy" />
          </div>
          <h3>Student Recognition Program</h3>
          <p>
            Awards and recognition for academic excellence, leadership, and service.
          </p>
          <span class="program-tag">Annual</span>
        </div>
      </div>
    </section>

    <section class="content-section">
      <h2>
        <i class="fas fa-calendar section-icon" />
        Annual Activities Calendar
      </h2>
      <div class="calendar-grid">
        <div class="calendar-item">
          <div class="month">
            June - July
          </div>
          <div class="activity">
            New Student Orientation
          </div>
        </div>
        <div class="calendar-item">
          <div class="month">
            August
          </div>
          <div class="activity">
            Leadership Summit
          </div>
        </div>
        <div class="calendar-item">
          <div class="month">
            October
          </div>
          <div class="activity">
            Mental Health Awareness Week
          </div>
        </div>
        <div class="calendar-item">
          <div class="month">
            November
          </div>
          <div class="activity">
            Career Fair
          </div>
        </div>
        <div class="calendar-item">
          <div class="month">
            December
          </div>
          <div class="activity">
            Community Outreach / Gift Giving
          </div>
        </div>
        <div class="calendar-item">
          <div class="month">
            February
          </div>
          <div class="activity">
            Values Formation Week
          </div>
        </div>
        <div class="calendar-item">
          <div class="month">
            March
          </div>
          <div class="activity">
            Women's Month Celebration
          </div>
        </div>
        <div class="calendar-item">
          <div class="month">
            April
          </div>
          <div class="activity">
            Student Recognition Day
          </div>
        </div>
      </div>
    </section>

    <section class="content-section highlight">
      <h2>
        <i class="fas fa-life-ring section-icon" />
        Support Services
      </h2>
      <p>
        In addition to our programs, we provide ongoing support services for all students:
      </p>
      <div class="support-list">
        <div class="support-item">
          <i class="fas fa-check-circle" />
          <span>Counseling and psychological services</span>
        </div>
        <div class="support-item">
          <i class="fas fa-check-circle" />
          <span>Health and medical assistance</span>
        </div>
        <div class="support-item">
          <i class="fas fa-check-circle" />
          <span>Scholarship and financial assistance referral</span>
        </div>
        <div class="support-item">
          <i class="fas fa-check-circle" />
          <span>Student organization support</span>
        </div>
        <div class="support-item">
          <i class="fas fa-check-circle" />
          <span>Academic tutoring and peer support</span>
        </div>
        <div class="support-item">
          <i class="fas fa-check-circle" />
          <span>PWD and special needs assistance</span>
        </div>
      </div>
    </section>

    <section class="content-section">
      <h2>
        <i class="fas fa-phone section-icon" />
        Get Involved
      </h2>
      <p>
        Want to participate in our programs or learn more? Contact us:
      </p>
      <div class="contact-info">
        <div class="contact-item">
          <i class="fas fa-map-marker-alt" />
          <span>Room 200, Student Services Building</span>
        </div>
        <div class="contact-item">
          <i class="fas fa-phone" />
          <span>(078) 123-4567 Local 200</span>
        </div>
        <div class="contact-item">
          <i class="fas fa-envelope" />
          <span>osas@nc.edu.ph</span>
        </div>
      </div>
    </section>
  </ServicePageLayout>
</template>

<script>
import ServicePageLayout from '@/components/landing/ServicePageLayout.vue'

export default {
  name: 'ProgramsPage',

  components: {
    ServicePageLayout
  },

  metaInfo: () => ({
    title: 'Institutional Programs & Services'
  })
}
</script>
